/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Work_Order_Publish_Same_Start_EndInputs */



/**
* | output |
* | --- |
* | "Event {index} has the same start and end time. Would you like to ABORT your export?" |
*
* @param {Work_Order_Publish_Same_Start_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_same_start_end = /** @type {((inputs: Work_Order_Publish_Same_Start_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Same_Start_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L’événement ${i?.index} a la même heure de début et de fin.
 Voulez-vous ABANDONNER l’exportation ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} hat dieselbe Start- und Endzeit.
Möchten Sie den Export abbrechen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'evento ${i?.index} ha la stessa ora di inizio e fine.
Vuoi ANNULLARE l'esportazione?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} имеет одинаковое время начала и окончания.
Вы хотите ОТМЕНИТЬ экспорт?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El evento ${i?.index} tiene la misma hora de inicio y de fin.
¿Desea cancelar la exportación?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} 的开始时间和结束时间相同。

是否要中止导出操作？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} の開始時刻と終了時刻は同じです。
エクスポートを中止しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.index} का प्रारंभ और समाप्ति समय समान है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O evento ${i?.index} tem o mesmo horário de início e término.
Deseja CANCELAR a exportação?`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} has the same start and end time.
 Would you like to ABORT your export?`)
});